export const REDIRECT_AFTER_LOGIN = 'REDIRECT_AFTER_LOGIN';

